<template>
  <module-block
    class="home-instructions"
    block="lightest"
  >
    <h2 class="h2 home-instructions__heading mt0">You play a critical role in driving quality in dentistry</h2>
    <div class="home-instructions__inner group group--last">
      <div class="home-instructions__steps">
        <div
          v-for="(step, index) in instructionSteps"
          :key="index"

          class="home-instructions__step"
        >
          <div class="home-instructions__icon">
            <img
              :src="step.image"
              :alt="step.alt"
            >
          </div>
          <div class="home-instructions__content">
            <h4 class="home-instructions__heading h4 fw-bold">{{ step.heading }}</h4>
            <p class="p" v-html="step.copy" />
          </div>
        </div>
      </div>
    </div>
  </module-block>
</template>

<script>
// Modules
import ModuleBlock from 'modules/Block';

// Images
const images = {
  computer: require(`images/info/icon-tooth-computer.svg`),
  tooth: require(`images/info/icon-tooth-search.svg`),
  people: require(`images/info/icon-doctors.svg`),
  aaoe: require(`images/info/american-association-of-endodontists.svg`),
};

export default {
  name: `info-dentists-instructions`,

  // Components
  components: {
    ModuleBlock,
  },

  // Data
  data () {
    return  {
      images,
      instructionSteps: [
        {
          image: images.computer,
          alt: `Icon - VeriTooth Online verification`,
          heading: `VeriTooth Online verification`,
          copy: `VeriTooth provides dentists and patients a simple and secure environment to upload radiographs for \
                an expert review by a specialist. All patient and dentist information is hidden to protect privacy and ensure an unbiased review.`,
        },
        {
          image: images.tooth,
          alt: `Icon - Your Impartial Industry Expertise`,
          heading: `Your Impartial Industry Expertise`,
          copy: `An impartial qualified dental expert will do a short review of the radiographs against industry defined standards. \
                For example, you can verify a root canal using the <a class="link link--secondary tdn" ` +
                `href="https://www.aae.org/" target="_blank">AAE</a> (American Association of Endodontists) <a class="link link--secondary tdn" ` +
                `href="https://f3f142zs0k2w1kg84k5p9i1o-wpengine.netdna-ssl.com/specialty/wp-content/uploads/` +
                `sites/2/2018/04/TreatmentStandards_Whitepaper.pdf" target="_blank">Standard of Treatment criteria</a>. \
                Reviews only take a minute and your identity is hidden from the patient and dentist. It’s completely anonymous.<br /><br />\
                <img src="${images.aaoe}" alt="Icon - American Association of Endodontist" />`,
        },
        {
          image: images.people,
          alt: `Icon - Demonstrated Quality`,
          heading: `Demonstrated Quality`,
          copy: `Now patients will get clear feedback on the quality of the dental work without impacting dentist’s relationships. \
                VeriTooth also takes these quality scores from all our reviews to build a directory of local dental care providers. \
                Finally, dentists can prove their good quality and patients can make a more informed choice.`,
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Instructions.vue?67cc753c